<template>
  <div>
    
    <div v-if="hascards" class="mt-5 mb-3 border-bottom">
      <h5>Saved cards</h5>
      <b-table-lite :items="checkout.stripe_cards" :fields="card_fields" class="cc-table-data" thead-class="d-none" fixed>
        <template #cell(sel)="{item:card}">
          <b-form-radio v-model="chosen_card" name="choose_card" :value="card.id" :required="!add_card" :form="formid"/>
        </template>
        <template #cell(card)="{item:card}">
          <div class="d-flex align-items-center">
            <b-icon icon="credit-card2-front-fill" font-scale="3" class="mr-3"/>
            <div>
              <p class="lead mb-1">{{card.name}}</p>
              <p class="small text-muted mb-1">{{card.brand}} ending with {{card.last4}}</p>
              <p class="small text-muted mb-1">Expires: {{String(card.exp_month).padStart(2, "0")}}/{{String(card.exp_year).slice(-2)}}</p>
            </div>
          </div>
        </template>

        
      </b-table-lite>
      <p class="small text-muted">Manage your saved cards via your donation dashboard</p>
    </div>
    <div v-if="add_card">
      <card-anon :checkout="checkout" ref="card_element" :formid="formid"/>
      <b-form-checkbox v-model="save_card" v-if="!force_save">Remember my card details for next time. (via Stripe)</b-form-checkbox>
    </div>
    <b-button v-else @click="add_card=true">Use a New Card</b-button>
  </div>
</template>

<script>
import cardAnon from './card-anon.vue';

export default {
    name:"card",
    props:{
        checkout: Object,
        axios:Function,
        formid: String,

    },
    components:{
      cardAnon
    },
    data(){
        let add_card = this.checkout?.stripe_cards?.length ? false : true;
        let save_card = true;
        let card_fields=[
          'sel',
          'card'

        ]
      return {add_card,save_card, card_fields, chosen_card: null};
    },
    methods:{
      async submit(){
          if(this.add_card){
            let save_card = this.save_card;
            let {token,error} = await this.$refs.card_element.get_token();
            if(error){
                throw 'Card Token error';
            }
            await this.axios.post('donations/'+this.ref,{
                action: 'pay',
                token,
                save_card
            });
            return;
          }
          if(this.chosen_card){
              await this.axios.post('donations/'+this.ref,{
                action: 'pay',
                token: {id:this.chosen_card},
                save_card: false
              });
              return;
          }
          throw "Need to choose a card"
          
        
        
      }
    },
    computed:{
      hascards(){ return this.checkout?.stripe_cards?.length;},
      force_save(){ return this.checkout.Donation_Frequency >0;},
      ref(){return this.checkout.Reference;}

    },
    watch:{
      chosen_card(v){
        if(v){
          this.add_card = false
        }
        
      },
      add_card(v){
        if(v){
          this.chosen_card = null;
        }
      }
    }
}
</script>

<style>

</style>